module.exports = __webpack_public_path__ + "img/volume_up_white_24dp.ac5c2753.svg";